module.exports = __webpack_public_path__ + "static/img/close.d8f2c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/close.png
// module id = w/x8
// module chunks = 66